/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    code: "code",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "TypeScript Plugin"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/Igorbek/typescript-plugin-styled-components",
        children: _jsx(_components.code, {
          children: "typescript-plugin-styled-components"
        })
      }), " is a plugin for TypeScript that gives you a nicer debugging experience."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["⚠️ TypeScript does not allow to use any plugin or transformer directly from the command line compiler ", _jsx(_components.code, {
          children: "tsc"
        }), ". So the plugin only works with build toolchains such as ", _jsx(_components.code, {
          children: "webpack"
        }), " with one of TypeScript loaders. There's ", _jsx(_components.a, {
          href: "https://github.com/Microsoft/TypeScript/issues/16607",
          children: "an open issue"
        }), " to bring plugins to tsc though if you want to upvote it!"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Please refer to ", _jsx(_components.a, {
        href: "https://github.com/Igorbek/typescript-plugin-styled-components",
        children: "the project's GitHub repo"
      }), " for documentation."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
